import { useMemo } from 'react';

import {
  InputGroupV2,
  MultiSelectOption,
  UniversalSelect,
} from '@equip.health/ui';

import { Recurrence, recurrenceLabelMapper } from '~/lib/util/calendar.util';
import {
  GroupClassBaseFieldProps,
  GROUP_CLASS_ACCORDION_TOP_LEVEL_ID,
} from '~/lib/types/classes/GroupClassAccordion';

interface GroupClassRecurrenceFieldProps
  extends GroupClassBaseFieldProps<Recurrence> {
  startDate: Date;
  isRecurring?: boolean;
}

export const GroupClassRecurrenceField = ({
  isDisabled,
  isEditMode,
  isRecurring,
  onChange,
  value,
  startDate,
  leftIcon,
}: GroupClassRecurrenceFieldProps) => {
  let recurrenceOptionsV2 = useMemo<MultiSelectOption[]>(
    () =>
      Object.values(Recurrence).map((recurrenceOption) => ({
        label: recurrenceLabelMapper[recurrenceOption],
        value: recurrenceOption,
      })) ?? [],
    [startDate],
  );

  // Remove Recurrence.DOES_NOT_REPEAT option if it is a recurring class. A GC cannot be updated as from recurring to "does not repeat"
  if (isEditMode && isRecurring) {
    recurrenceOptionsV2 = recurrenceOptionsV2.filter(
      (recurrenceOption: MultiSelectOption) => {
        return recurrenceOption.value !== Recurrence.DOES_NOT_REPEAT;
      },
    );
  }

  return (
    <InputGroupV2
      id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__recurrence`}
      isRequired
      label="Recurrence"
      shouldShowAsteriskWhenRequired
    >
      <UniversalSelect
        id={`${GROUP_CLASS_ACCORDION_TOP_LEVEL_ID}__recurrence-v2`}
        isDisabled={isDisabled}
        isSingleSelect
        leftIcon={leftIcon}
        onChange={(option) =>
          onChange((option as MultiSelectOption).value as Recurrence)
        }
        options={recurrenceOptionsV2}
        placeholder="Please choose"
        value={recurrenceOptionsV2.find((option) => option.value === value)}
      />
    </InputGroupV2>
  );
};
